export const couponList = [
  {
    key: "xianjin",
    color: "#F56C6C",
    coupon_name: "5元现金卷",
    stock_type: "xianjin",
    value1: "500",
    value2: "0"
  },
  {
    key: "xianjin",
    color: "#F56C6C",
    coupon_name: "10元现金卷",
    stock_type: "xianjin",

    value1: "1000",
    value2: "0"
  },
  {
    key: "xianjin",
    color: "#F56C6C",
    coupon_name: "20元现金卷",
    stock_type: "xianjin",
    value1: "2000",
    value2: "0"
  },
  {
    key: "manjian",
    color: "#409eff",
    coupon_name: "满100元减10元优惠",
    stock_type: "manjian",
    value1: "1000",
    value2: "10000"
  },
  {
    key: "manjian",
    color: "#409eff",
    coupon_name: "满100元减20元优惠",
    stock_type: "manjian",
    value1: "2000",
    value2: "10000"
  },
  {
    key: "manjian",
    color: "#409eff",
    coupon_name: "满200元减10元优惠",
    stock_type: "manjian",
    value1: "1000",
    value2: "20000"
  },
  {
    key: "xinyonghu",
    color: "#04BE02",
    coupon_name: "新用户专享",
    stock_type: "xinyonghu",
    value1: "1000",
    value2: "0"
  },
  {
    key: "xinyonghu",
    color: "#04BE02",
    coupon_name: "新用户专享",
    stock_type: "xinyonghu",
    value1: "2000",
    value2: "0"
  }, {
    key: "fenxiang",
    color: "#04BE02",
    coupon_name: "分享可减10元",
    stock_type: "fenxiang",
    value1: "1000",
    value2: "0"
  }, {
    key: "fenxiang",
    color: "#04BE02",
    coupon_name: "分享可减20元",
    stock_type: "fenxiang",
    value1: "2000",
    value2: "0"
  }
  /* ,
  {
    key: "discount",
    color: "#04BE02",
    coupon_name: "全场88折",
    stock_type: "DISCOUNT",
    value1: "88",
    value2: "1"
  },
  {
    key: "discount",
    color: "#04BE02",
    coupon_name: "全场85折",
    stock_type: "DISCOUNT",
    value1: "85",
    value2: "100000"
  },
  {
    key: "discount",
    color: "#04BE02",
    coupon_name: "全场8折",
    stock_type: "DISCOUNT",
    value1: "8",
    value2: "200000"
  } */
];
